interface DownloadFileProps {
  data: BlobPart;
  contentType: string;
  filename: string;
  isDownload?: boolean;
  isPreview?: boolean;
}

export default function downloadFile({
  data,
  contentType,
  filename,
  isDownload = true,
  isPreview = false
}: DownloadFileProps): void {
  const a = document.createElement('a');
  a.setAttribute('style', 'display: none');
  document.body.appendChild(a);

  const file = new Blob([data], { type: contentType });
  const url = URL.createObjectURL(file);

  if (isDownload) {
    a.href = url;
    a.download = filename;
    a.click();
  }
  if (isPreview) window.open(url);

  URL.revokeObjectURL(url);
  document.body.removeChild(a);
}
